export const iconFontAwesomeUsersPeoplePersonArrowDownToLine = (
	<i className="fa-solid fa-person-arrow-down-to-line"></i>
);
